import React from "react";
import { Outlet } from "react-router-dom";
import TicketsTypesRouts from "../../Components/TicketTypesRouts/TicketsTypesRouts";

function TicketsRouts() {
  return (
    <>
      <TicketsTypesRouts />
      <Outlet />
    </>
  );
}

export default TicketsRouts;
